import { DESCENDER_RATIO_PER_FONT_SIZE } from '@app/components/TextField/constants';
import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import { getTextBaseFieldMinimumSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/getTextBaseFieldMinimumSize';
import { ADDRESS_MAX_LENGTH } from '@app/features/apply-react-signing/components/FieldRenderer/Setup/FieldRenderers/ConfigurableAddressFieldRenderer';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

const LINE_COUNT_FOR_MIN_SIZE = 3;

export function getAddressFieldCorrectedSize({
  size,
  fontSize,
  scale,
}: {
  size: AbsoluteSize;
  fontSize: number;
  scale: number;
}) {
  const fontPixelSize: number = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);

  const descenderHeight = fontPixelSize * DESCENDER_RATIO_PER_FONT_SIZE;

  const currentSize = getTextBaseFieldMinimumSize(fontSize, scale);
  const minimumSize = getTextBaseFieldMinimumSize(4, scale);

  const calculateHeight = (totalHeight: number, lineHeight: number) =>
    Math.floor(totalHeight / lineHeight) * lineHeight + descenderHeight;
  const width = Math.max(
    size.width,
    currentSize.width,
    (ADDRESS_MAX_LENGTH * minimumSize.width) / LINE_COUNT_FOR_MIN_SIZE
  );
  const height = Math.max(
    calculateHeight(size.height, fontPixelSize),
    minimumSize.height * LINE_COUNT_FOR_MIN_SIZE,
    currentSize.height
  );

  return createAbsoluteSize({ width, height });
}
